<template>
	<div class="p-home">
    <div class="banners" @mouseover="banner.pause=true" @mouseleave="banner.pause=false">
      <div class="inner" :style="{transform:`translate3d(-${banner.index*100}%,0,0)`}">
        <router-link class="banner" :style="{backgroundImage:`url('${o.bg}')`}" v-for="(o,i) in banner.list" :key="i" :to="o.link" :target="o.target">
          <v-image :src="o.img"/>
        </router-link>
      </div>
      <div class="dots">
        <div class="dot" :class="{active:i==banner.index}" v-for="(o,i) in banner.list" :key="i" @click="banner.index=i"></div>
      </div>
    </div>
    <div class="part">
      <img src="/image/home/1.png"/>
    </div>
    <div class="part t2">
      <img src="/image/home/2.png"/>
    </div>
    <div class="part t3">
      <img src="/image/home/3.png"/>
    </div>
    <div class="part">
      <div class="title">三大解决方案，满足广泛的业务需求</div>
      <div class="links">
        <a class="link" :class="`t4${i+1}`" v-for="(o,i) in links" :key="i">
          <div class="img" :style="{backgroundImage:`url('${o.img}')`}"></div>
          <div class="title">{{o.title}}</div>
          <div class="desc" :title="o.desc">{{o.desc}}</div>
        </a>
      </div>
    </div>
    <div class="part t5">
      <img src="/image/home/5.png"/>
    </div>
	</div>
</template>

<script>
export default {
  data() {
    return {
      links: [
        {
          title: "一站式体重管理解决方案",
          desc: "适用于专业体重管理公司、健身房、美容院等机构",
          img: "/image/home/41.jpg",
        },
        {
          title: "一站式老年营养解决方案",
          desc:
            "基于中国老年营养餐行业标准，提供包括营养筛查、营养配餐及营养咨询等，为老年服务机构提供专业的营养管理与干预",
          img: "/image/home/42.jpg",
        },
        {
          title: "社区营养与健康管理解决方案",
          desc:
            "适用于传统保健企业转型健康管理，适用于基层医疗卫生机构服务升级",
          img: "/image/home/43.jpg",
        },
      ],
      banner: {
        index: 0,
        direction: 1,
        pause: false,
        list: [
          {
            bg: "/image/home/banner/2-bg.jpg",
            img: "/image/home/banner/2.png",
            link: "/activity/cater2021",
            target: false,
          },
          {
            bg: "/image/home/banner/1-bg.jpg",
            img: "/image/home/banner/1.png",
            link: "//wpa.qq.com/msgrd?v=3&uin=1685607977&menu=yes",
            target: "_blank",
          },
          {
            bg: "/image/home/banner/3-bg.jpg",
            img: "/image/home/banner/3.png",
            link: "//wpa.qq.com/msgrd?v=3&uin=1685607977&menu=yes",
            target: "_blank",
          },
        ],
      },
    };
  },
  created() {
    setInterval(() => {
      if (!this.banner.pause) {
        if (this.banner.index == 0) {
          this.banner.direction = 1;
        } else if (this.banner.index == this.banner.list.length - 1) {
          this.banner.direction = -1;
        }
        this.banner.index += this.banner.direction;
      }
    }, 4000);
  },
};
</script>

<style lang="less">
.p-home {
  > .banners {
    height: 450px;
    overflow: hidden;
    min-width: 1000px;
    position: relative;
    > .inner {
      height: 100%;
      white-space: nowrap;
      transition: 800ms;
      > .banner {
        width: 100%;
        height: 100%;
        cursor: pointer;
        overflow: hidden;
        display: inline-block;
        background-size: cover;
        background-position: 50%;
        background-repeat: no-repeat;
        > .v-image {
          width: 1000px;
          height: 100%;
          display: block;
          margin: 0px auto;
        }
      }
    }
    > .dots {
      left: 50%;
      bottom: 0px;
      position: absolute;
      transform: translate3d(-50%, 0, 0);
      > .dot {
        width: 6px;
        height: 6px;
        margin: 10px;
        cursor: pointer;
        border-radius: 50%;
        display: inline-block;
        background-color: rgba(255, 255, 255, 0.6);
        &:hover {
          transform: scale(1.5);
        }
        &.active {
          background-color: rgba(255, 255, 255, 1);
        }
      }
    }
  }
  > .part {
    padding: 80px 0px;
    &.t2 {
      background-color: #f1f2f6;
    }
    &.t3 {
      background-color: #262930;
    }
    &.t5 {
      background-color: #f4f3f8;
    }
    &.t6 {
      background-color: #262930;
    }
    > img {
      width: 1010px;
      display: block;
      margin: 0px auto;
    }
    > .title {
      font-size: 32px;
      color: #41d1ae;
      text-align: center;
      margin-bottom: 60px;
    }
    > .links {
      width: 1010px;
      display: flex;
      margin: 0px auto;
      align-items: center;
      justify-content: space-between;
      > .link {
        width: 310px;
        height: 276px;
        display: flex;
        line-height: 24px;
        position: relative;
        flex-direction: column;
        box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
        &:hover {
          > .img {
            height: 80px;
          }
          > .title {
            margin-top: 20px;
          }
          > .desc {
            overflow: auto;
            white-space: initial;
          }
        }
        &.t41 {
          > .title::after {
            background-color: #3a8bfe;
          }
        }
        &.t42 {
          > .title::after {
            background-color: #2fcdd0;
          }
        }
        &.t43 {
          > .title::after {
            background-color: #65c9fb;
          }
        }
        > .img {
          height: 188px;
          background-size: cover;
          background-position: 50%;
          background-repeat: no-repeat;
          transition: 200ms;
        }
        > .title {
          font-size: 16px;
          color: #333333;
          margin: 10px 20px;
          font-weight: bold;
          text-align: center;
          &::after {
            left: 50%;
            width: 30px;
            height: 3px;
            content: "";
            display: block;
            margin: 0px auto;
            position: absolute;
            text-align: center;
            border-radius: 1.5px;
            transform: translate3d(-50%, 9px, 0);
          }
        }
        > .desc {
          flex: 1;
          height: 0px;
          color: #999999;
          overflow: hidden;
          margin: 10px 20px;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
    }
  }
}
</style>